import { render, staticRenderFns } from "./EmployeeTable.vue?vue&type=template&id=704878cf&scoped=true&"
import script from "./EmployeeTable.vue?vue&type=script&lang=js&"
export * from "./EmployeeTable.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeTable.vue?vue&type=style&index=0&id=704878cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704878cf",
  null
  
)

export default component.exports